import { ExtTaskData } from "../../../../cuba/entities/base/tsadv_ExtTaskData";

export const findMyActiveTask = (
  tasks: ExtTaskData[] | undefined,
  userId: string | undefined,
): ExtTaskData | undefined => {
  if (!tasks || !userId) return undefined;

  for (const task of tasks) {
    if (task.assignee === userId && !task.endTime) return task;

    if (task.childs?.length) {
      const result = findMyActiveTask(task.childs, userId);
      if (result) return result;
    }
  }
  return undefined;
};
